import React from "react";
import { Container } from "reactstrap";
import BookingSettings from "./BookingSettings";

// Pagina Settings delle prenotazioni (voce della sidebar sotto Bookings).
const BookingSettingsPage = () => (
  <div className="content">
    <Container fluid>
      <BookingSettings />
    </Container>
  </div>
);

export default BookingSettingsPage;
